import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Children, useMemo } from "react";
import JsonLd from "../../../../../base/others/json-ld/index.js";
import Title from "../../../../../base/text/title/index.js";
import ProductCard from "../../../../cards/product-card/views/desktop/index.js";
import CardSkeletonDesktop from "../../../../cards/product-card/views/desktop/card-skeleton/index.js";
import { genKey } from "../../../../../../helpers/keys.js";
import useCurrentBreakpoint from "../../../../../../hooks/media/useCurrentBreakpoint.js";
import CardViewMore from "./card-view-more/index.js";
import * as S from "./styled.js";
export const GridProductDesktop = ({ props  })=>{
    const { title , ldjson , items , link , config , isLoading =false , searcher , isFirstComponent  } = props ?? {};
    const currentBreakpoint = useCurrentBreakpoint();
    const breakpointRows = useMemo(()=>({
            xxl: 4,
            xl: 3,
            lg: 2,
            md: 2,
            sm: 2,
            xs: 2,
            ...config?.gridProductBreakpoints
        }), [
        config?.gridProductBreakpoints
    ]);
    const skeleton = useMemo(()=>new Array(breakpointRows[currentBreakpoint]).fill(/*#__PURE__*/ _jsx(S.CardSkeletonWrapper, {
            children: /*#__PURE__*/ _jsx(CardSkeletonDesktop, {})
        })), [
        breakpointRows,
        currentBreakpoint
    ]);
    const getProductCards = ()=>{
        const productCards = Children.toArray(items?.map((item)=>{
            const generalConfig = {
                ...config,
                ...item?.config
            };
            const literals = {
                ...item.config?.literals,
                ...config?.literals
            };
            return /*#__PURE__*/ _jsx(ProductCard, {
                searcher: searcher,
                ...item,
                config: {
                    ...generalConfig,
                    literals
                },
                isFirstComponent: isFirstComponent
            });
        }));
        if (!link?.href) return productCards;
        return productCards.concat(/*#__PURE__*/ _jsx(CardViewMore, {
            link: link,
            content: config?.literals?.viewMore
        }, genKey({
            productCardsViewMoreLink: link
        })));
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            title && /*#__PURE__*/ _jsx(Title, {
                ...title
            }),
            /*#__PURE__*/ _jsx(S.GridWrapper, {
                "data-testid": "GridProduct",
                breakpoints: breakpointRows,
                children: isLoading ? Children.toArray(skeleton) : getProductCards()
            }),
            Children.toArray(ldjson?.scripts?.map((script)=>/*#__PURE__*/ _jsx(JsonLd, {
                    structuredData: script
                })))
        ]
    });
};
export default GridProductDesktop;

//# sourceMappingURL=index.js.map